module.exports = __webpack_public_path__ + "img/男-糖尿病h.5e472afe.png";